import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './Material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { appNoSpaceAtFirst } from './directives/no-space.directive';
import { TextOnlyAllowDirective } from './directives/only-text.directive';
import { DecimalDirectiveDirective } from './directives/decimal-point.directive';
@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NumberOnlyDirective,
    appNoSpaceAtFirst,
    TextOnlyAllowDirective,
    DecimalDirectiveDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,

  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    NumberOnlyDirective,
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    appNoSpaceAtFirst,
    TextOnlyAllowDirective,
    DecimalDirectiveDirective

  ]
})
export class SharedModule { }
